var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotAllow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.5104,2.4895899999999997Q12.0208,0,8.5,0Q4.97918,0,2.4895899999999997,2.4895899999999997Q0,4.97918,0,8.5Q-0.0000010000000000287557,12.0208,2.4895899999999997,14.5104Q4.97918,17,8.5,17Q12.0208,17,14.5104,14.5104Q17,12.0208,17,8.5Q17,4.97918,14.5104,2.4895899999999997ZM3.1967,3.1967Q5.3934,1.0000010000000001,8.5,1.0000010000000001Q11.247,1,13.2825,2.71752L2.71752,13.2825Q1,11.2469,1,8.5Q1,5.3934,3.1967,3.1967ZM3.40731,14.0069Q5.54087,16,8.5,16Q11.6066,16,13.8033,13.8033Q16,11.6066,16,8.5Q16,5.54087,14.0069,3.40731L3.40731,14.0069Z",
    fillRule: "evenodd",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAllow);
export default __webpack_public_path__ + "static/media/not_allow.6c99c6b11b9c10c22ad30d34c7b86890.svg";
export { ForwardRef as ReactComponent };